import { compact, isNumber } from 'lodash-es';
import { numberWithCommas } from 'site-modules/shared/utils/string';

export function getDealershipsLandingTitle({ totalNumber, makeName, useSimpleTitle, city, stateCode }) {
  if (makeName) {
    return compact([isNumber(totalNumber) && numberWithCommas(totalNumber), makeName, 'Dealerships Found']).join(' ');
  }

  return compact([
    !useSimpleTitle && isNumber(totalNumber) && numberWithCommas(totalNumber), // only show total number on the client side
    'Car Dealerships Near',
    useSimpleTitle ? 'Me' : `${city}, ${stateCode}`, // only city/state on the client side
  ]).join(' ');
}
